<template>
  <div class="form-container">
    <h1 class="page-title">業務区分マスタ情報編集</h1>
    <form @submit.prevent="handleSubmit" @keydown.enter.prevent>
      <div class="mb-3">
        <label for="id" class="form-label">ID：</label>
        {{ business_classification.id}}
      </div>

      <div class="mb-3">
        <label for="business_classificationName" class="form-label">業務区分名 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="business_classification.business_classification_nm" type="text" placeholder="業務区分名" class="form-control" id="business_classificationName" required>
        <div v-if="errorMessages.business_classification_nm" class="alert alert-danger mt-2">{{ errorMessages.business_classification_nm[0] }}</div>
      </div>

      <div class="mb-3">
        <label for="sortNo" class="form-label">並び順 <span class="badge text-bg-danger">必須</span></label>
        <input v-model="business_classification.sort_no" type="number" step="1" min="1" placeholder="並び順" class="form-control" id="sortNo" required>
        <div v-if="errorMessages.sort_no" class="alert alert-danger mt-2">{{ errorMessages.sort_no[0] }}</div>
      </div>

      <div class="btn-area">
        <a class="btn btn-secondary mx-1" @click="$router.back()">戻る</a>
        <button type="submit" class="btn btn-success mx-1">更新</button>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { getBusinessClassification, updateBusinessClassification } from '@/api/axios';

export default {
  setup() {
    const title = ref('業務区分情報編集');

    watchEffect(() => {
      document.title = title.value;
    });

    const business_classification = ref({
      business_classification_nm: '',
      sort_no: '',
      // 他のフィールド
    });

    // エラーメッセージ用のリアクティブプロパティ
    const errorMessages = ref({});

    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const businessClassificationId = route.params.id; // URLから業務区分情報IDを取得

    const loadBusinessClassificationData = async () => {
      try {
        const response = await getBusinessClassification(businessClassificationId);
        business_classification.value = response.data;
      } catch (error) {
        console.error('業務区分情報データの取得に失敗しました:', error);
      }
    };

    const handleSubmit = async () => {
      try {
        await updateBusinessClassification(businessClassificationId, business_classification.value);
        store.dispatch('setFlashMessage', {message: '業務区分情報更新完了！', type: 'success'});
        router.push('/business-classifications');
      } catch (error) {
        if (error.response && error.response.data) {
          // エラーメッセージをerrorMessagesにセット
          errorMessages.value = error.response.data || {};
        }
        store.dispatch('setFlashMessage', {message: '業務区分情報更新失敗！', type: 'danger'});
        console.error('更新エラー:', error);
      }
    };

    onMounted(loadBusinessClassificationData);

    return {
      title,
      business_classification,
      handleSubmit,
      errorMessages
    };
  }
};
</script>
